import { useState } from "react";
import { ReactComponent as FAQQuestionIcon } from "assets/icons/faq_question.svg";
import { ReactComponent as ArrowDownIcon } from "assets/icons/arrow_down.svg";

const FAQ = () => {
  const [expandedSection, setExpandedSection] = useState({});

  const toggleExpand = (sectionIndex, itemIndex) => {
    setExpandedSection((prev) => ({
      ...prev,
      [sectionIndex]: prev[sectionIndex] === itemIndex ? null : itemIndex,
    }));
  };

  return (
    <>
      <div className="bg-white rounded-[15px] h-full overflow-auto px-[17px] sm:px-[30px] sm:pt-[27px] pb-[17px] sm:pb-[35px]">
        <div className="w-full lg:max-w-[540px]">
          <h2 className="hidden sm:block input-label">FAQ e Assistenza</h2>
          <div className="sm:mt-[37px]">
            {faqData.map(({ title, contents }, sectionIndex) => (
              <div className="mt-[23px]">
                <Section
                  title={title}
                  faqs={contents}
                  expanded={expandedSection[sectionIndex]}
                  toggleExpand={(itemIndex) =>
                    toggleExpand(sectionIndex, itemIndex)
                  }
                />
              </div>
            ))}
          </div>
        </div>
        {/* desktop  */}
        <div className="hidden sm:block text-center mt-[53px] max-w-[507px] mx-auto">
          <h2 className="input-label !text-[20px]">
            Hai ancora bisogno di aiuto?
          </h2>
          <p className="mt-3 text-[#373C47] font-normal text-[14px] leading-[1.2]">
            Puoi inviare una email a support@housescan.it, oppure puoi
            contattarci in una delle nostre pagine social, LinkedIn, Facebook
            oppure Instagram. Ti risponderemo il prima possibile!
          </p>
        </div>
      </div>

      {/* mobile  */}
      <div className="block sm:hidden text-center mt-[19px] w-full mx-auto">
        <h2 className="input-label !text-[20px]">
          Hai ancora bisogno di aiuto?
        </h2>
        <p className="mt-3 text-[#373C47] font-normal text-[14px] leading-[1.2]">
          Puoi inviare una email a support@housescan.it, oppure puoi contattarci
          in una delle nostre pagine social, LinkedIn, Facebook oppure
          Instagram. Ti risponderemo il prima possibile!
        </p>
      </div>
    </>
  );
};

const Section = ({ title, faqs, expanded, toggleExpand }) => (
  <div>
    {/* <h2 className="input-label !text-[20px]">{title}</h2> */}
    <div className="mt-[12px] flex flex-col space-y-5">
      {faqs.map((faq, index) => (
        <FAQItem
          key={index}
          index={index}
          question={faq.question}
          answer={faq.answer}
          expanded={expanded === index}
          toggleExpand={() => toggleExpand(index)}
        />
      ))}
    </div>
  </div>
);

const FAQItem = ({ index, question, answer, expanded, toggleExpand }) => (
  <div
    onClick={toggleExpand}
    className="py-[11px] pl-[14px] pr-[21px] bg-white rounded-[5px] border-[1px] border-[#F2F4F6] faq-box-shadow cursor-pointer"
  >
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center space-x-[7.15px]">
        <FAQQuestionIcon className="min-w-[21px]" />
        <p className="text-[16px] font-normal leading-[28px] text-[#271F1F]">
          {question}
        </p>
      </div>
      <ArrowDownIcon
        className={`transition-transform duration-500 ${
          expanded ? "-rotate-180" : "rotate-0"
        }`}
      />
    </div>
    <div
      className={`overflow-hidden transition-max-height duration-500 ease-in-out ${
        expanded ? "max-h-[1000px]" : "max-h-0"
      }`}
    >
      <p className="text-[14px] text-[#271F1F] leading-[28px] font-normal mt-[18px]">
        {answer}
      </p>
    </div>
  </div>
);

const faqData = [
  {
    title: "Iniziare",
    contents: [
      {
        question: "Come avviene la ricerca immobiliare?",
        answer:
          "scannerizziamo centinaia di annunci immobiliari di diverse piattaforme di ricerca immobiliare e forniamo i risultati in un unico posto.",
      },
      {
        question: "Quali vantaggi offriamo rispetto alle altre piattaforme?",
        answer:
          "Una sola ricerca, decine di portali scannerizzati. Inoltre forniamo i risultati con informazioni avanzate legate alla storicità dell'annuncio, alle rendite locative e alla location intelligence",
      },
      {
        question: "Come funziona lo scanner immobiliare?",
        answer:
          "Scannerizziamo le più importanti piattaforme di annunci immobiliari e forniamo in un unico posto tutti i risultati della ricerca multiportale",
      },
      {
        question: "Cosa indica la storicità dell’annuncio?",
        answer:
          "Per ogni annuncio forniamo la storia completa monitorando da quanto tempo è presente sul mercato tracciando eventuali variazioni di prezzo",
      },
    ],
  },
  {
    title: "Contenuti",
    contents: [
      {
        question: "Cos’è la location intelligence?",
        answer:
          "Utilizza l’intelligenza artificiale per ottenere info sui servizi disponibili nelle vicinanze, e capire la logistica urbana degli spostamenti",
      },
      {
        question: "Cos’è l’organizer immobiliare?",
        answer:
          "E' il primo aggregatore di annunci immobiliari di diverse piattaforme. Anche se navigli sui tuoi portali preferiti, grazie all'estensione potrai salvare tutti gli annunci in un unico posto",
      },
    ],
  },
  {
    title: "Pagamenti, Abbonamento e Beta",
    contents: [
      {
        question: "E’ possibile creare liste di annunci e condividerli?",
        answer:
          "Si, è possibile salvare gli annunci preferiti e organizzarli in cartelle personalizzate. Inoltre è possibile condividere le cartelle con chi vuoi e aggiornare in tempo reale le cartelle",
      },
      {
        question: "Che vantaggi offre la dashboard personale?",
        answer:
          "Ogni profilo ha accesso ad una dashboard riepilogativa che fornisce una serie di informazioni personalizzate sull'aggiornamento deli prezzi delle proprietà salvate, suggerimenti di proprietà con il miglior rapporto prezzo/mq e indicazione di zone ad alte rendite locative dove investire",
      },
      {
        question:
          "Per accedere alla piattaforma devo sottoscrivere un abbonamento?",
        answer:
          "No, in questa fase di Beta test non è richiesto nessun abbonamento. Dal Lancio della piattaforma offriremo per i nuovi iscritti la possibilità di accedere alla versione premium con tutte le funzionalità gratis per due settimane. Al termine potrai scegliere il piano più adatto a te",
      },
    ],
  },
  {
    title: "Utilizzo Piattaforma",
    contents: [
      {
        question: "E’ richiesta la carta di credito?",
        answer:
          "No, nessuna carta di credito è richiesta. Per accedere basta la mail. Al termine del periodo di prova PREMIUM di due settimane decidi se fare downgrade al FREE gratis o passare al piano in abbonamento con tutte le funzionalità sbloccate",
      },
      {
        question: "Che piani di abbonamento offrite?",
        answer:
          "Due, uno FREE con accesso alla ricerca multiportale e all'organizer e uno PREMIUM con tutte le funzionalità sbloccate.",
      },
    ],
  },
];

export default FAQ;
